if (!customElements.get('swiper-component')) {
  class SwiperComponent extends HTMLElement {
    constructor () {
      super();
      this.slider = null;
      this.initialized = false;
    }

    connectedCallback () {
      if (!this.initialized) {
        this.initSlider();
        this.initialized = true;
      }
    }

    set afterInit(callback) {
      this._afterInit = callback;
      if (typeof callback === 'function' && this.slider) {
        callback(this.slider);
      }
    }
    get afterInit() {
      return this._afterInit;
    }

    initSlider () {
      const id = this.getAttribute('id') || 'default-slider';
      const slidesPerView = this.getAttribute('slidesPerView') || 'auto';
      const spaceBetween = this.getAttribute('spaceBetween')|| 18;
      const centeredSlides = this.getAttribute('centeredSlides') === 'true';
      const initialSlide = parseInt(this.getAttribute('initialSlide') || 0);
      const loop = this.getAttribute('loop') === 'true';
      const useNavigation = this.getAttribute('useNavigation') === 'true';
      const usePagination = this.getAttribute('usePagination') === 'true';
      const speed = this.hasAttribute('speed') ? parseInt(this.getAttribute('speed')) : null;
      const delay = this.hasAttribute('delay') ? parseInt(this.getAttribute('delay')) : null;
      const autoplay = this.getAttribute('autoplay') === 'true';
      const disableOnInteraction = this.getAttribute('disableOnInteraction') === 'true';
      const pauseOnMouseEnter = this.getAttribute('pauseOnMouseEnter') === 'true';
      const breakpoint = parseInt(this.getAttribute('breakpoint') || 750);
      const initialSlideDesktop = parseInt(this.getAttribute('initialSlideDesktop')) || null;
      const spaceBetweenDesktop = this.getAttribute('spaceBetweenDesktop') || null;
      const slidesPerViewDesktop = this.getAttribute('slidesPerViewDesktop') || null;
      const disableCenteredSlidesDesktop = this.getAttribute('disableCenteredSlidesDesktop') === 'true';

      this.params = null;

      try {
        let params = this.querySelector('[data-params]')?.textContent;
        if (params) {
          this.params = JSON.parse(params);
        }
      } catch (e) {
        console.log(e);
      }
      let defaultParams = {
        slidesPerView,
        spaceBetween,
        centeredSlides,
        initialSlide,
        loop,
        freeMode: false,
        navigation: useNavigation ? {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        } : false,
        pagination: usePagination ? {
          el: `#${id} .swiper-pagination`,
          type: this.getAttribute('paginationType') || 'bullets',
          clickable: true,
        } : false,
        breakpoints: {
          [breakpoint]: {
            ...(initialSlideDesktop !== null && { initialSlide: initialSlideDesktop }),
            ...(spaceBetweenDesktop !== null && { spaceBetween: spaceBetweenDesktop }),
            ...(slidesPerViewDesktop !== null && { slidesPerView: slidesPerViewDesktop }),
            ...(disableCenteredSlidesDesktop && { centeredSlides: false }),
          },
        },
      };
      if(autoplay) {
        defaultParams['autoplay'] = {};
        if(typeof speed != 'undefined' && speed!==null) {
          defaultParams['speed'] = speed;
        }
        if(typeof delay !== 'undefined' && delay!==null) {
          defaultParams['autoplay']['delay'] = delay;
        }
        if(disableOnInteraction) {
          defaultParams['autoplay']['disableOnInteraction'] = disableOnInteraction;
        }
        if(pauseOnMouseEnter) {
          defaultParams['autoplay']['pauseOnMouseEnter'] = pauseOnMouseEnter;
        }
      }
      if (this.params) {
        defaultParams = { ...defaultParams, ...this.params };
      }
      this.slider = new Swiper(`#${id} .swiper`, defaultParams);


      this.slider.on('slideChange', function (slide) {
        const media = slide.el.querySelector('video, iframe');
        if (media) {
          window.pauseAllMedia();
        }
      });
    }
  }

  customElements.define('swiper-component', SwiperComponent);
}
